export default {
	en_US: 'en_US',
	nl_NL: 'nl_NL'
};
